import {
    useSpeculativeProjects,
    useTrackedQueueProjects
} from "in_queue/contexts/ProjectDataContext";
import { useMemo } from "react";

/** Ids of the projects in the user's portfolio, tracked queue plus speculative. */
export const usePortfolioProjectIds = (): ReadonlySet<string> => {
    const trackedProjects = useTrackedQueueProjects();
    const speculativeProjects = useSpeculativeProjects();

    return useMemo(
        () =>
            new Set([
                ...(trackedProjects === "loading"
                    ? []
                    : trackedProjects.map((project) => project.projectId)),
                ...(speculativeProjects === "loading"
                    ? []
                    : speculativeProjects.map((project) => project.projectId))
            ]),
        [trackedProjects, speculativeProjects]
    );
};
